// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__5YUKJ","info":"PatientInfo_info__jLsIE"};